module.exports = __webpack_public_path__ + "media/images/other/main-4f44e5fb95321363e933f259ff0200db.jpg";